import { FC, useEffect } from 'react';
import { redirectToLanding } from 'common/helpers/navigation.helper';

/* Корень без пути и неизвестный путь страницы ведут на лендинг (pay-host R-2). */
export const LandingRedirect: FC = () => {
  useEffect(() => {
    redirectToLanding();
  }, []);

  return null;
};
